<template>
  <img v-if="src" :src="src" :alt="alt" :title="alt" />
</template>

<script>
export default {
  name: "WordPressImage",
  props: {
    image: {
      type: Object,
      default() {
        return null;
      }
    },
    size: {
      type: String,
      default() {
        return "post-thumbnail";
      }
    }
  },
  computed: {
    alt() {
      return this.image.alt;
    },
    src() {
      try {
        if (this.image && this.image.sizes) {
          return this.image.sizes[this.size]
            ? this.image.sizes[this.size]
            : null;
        }
      } catch (ex) {
        // console.error("Error getting image", { image: this.image, error: ex });
      }
      return null;
    }
  }
};
</script>
